import { AfterContentInit, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatchService } from 'src/app/service/match.service';
import { NgxSpinnerService } from "ngx-spinner";
import { AuthService } from 'src/app/service/auth.service';
import { SocketService } from 'src/app/service/socket.service';
import { UserService } from 'src/app/service/user.service';
import { BetService } from '../service/bet.service';


@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit, AfterContentInit {

  status: Boolean;
  result: Boolean;
  match: any[] = [];
  sort: number;
  matchSubs: Subscription;
  mobileSize:boolean = false
    userName: any;
  name: any;
  userId: any;
  user: any;
  message: any;
  private userSubs: Subscription;
  private messageSubs: Subscription;
  constructor(private authService: AuthService, private userService: UserService, private betService:BetService,
    private socketService: SocketService, private matchService: MatchService, private spinner: NgxSpinnerService) { }

   ngOnInit(): void {

    setTimeout(() => {
    this.betService.setAllBets();
    }, 1000);
    this.getAllBetsAll();
      this.userName = this.authService.getUserName();
    this.name = this.authService.getName();
    this.userId = this.authService.getUserId();
    this.userService.getUserById(this.userId);
    this.socketService.setMessage();
    this.socketService.getMessage();
    this.userSubs = this.userService.getUpdateUserListner().subscribe(data => {
      this.user = data.result;
      //console.log(this.user);
    }, error => {
      console.log(error);
    });

    this.messageSubs = this.socketService.getUpdateMessageListner().subscribe(data => {
      this.message = data.message;
    });


     if (window.innerWidth < 768) {
    this.mobileSize = true
  } else {
    this.mobileSize = false
  }

    this.sort = 1;
    this.spinner.show();
    this.status = true;
    this.result = false;
    this.match = []
    this.matchService.getMatches(this.status, this.result, this.sort);
    this.matchSubs = this.matchService.getUpdateMatchesListner().subscribe((data:any) => {
      this.spinner.hide();
      this.match=[]
      // console.log(data.matches.result,'ajay')
      let matches = data.matches.result
       for (let i = 0; i < matches.length; i++) {
          const element = matches[i];
            // console.log(element,'element')
            if(element.sportId =='4'){
              let nda = JSON.parse(data?.matches?.data2[element.eventId]?.diamondOdds)?.bf[0]?.sort((a:any,b:any)=>(a> b ? -1:1))
              // console.log(nda,'ndasss')
              this.match.push({...element, ndata: nda})
            }
        }
        
      
      // this.match = data.matches;
      // console.log(this.match);
    }, error => {
      this.spinner.hide();
      // console.log(error);
    });
  }



    markets: any[] = [];
  betsData: any = {};

  getAllBetsAll(){
    this.betService.getAllBets().subscribe((res:any)=>{
      // console.log(res)
       const bets = res || [];
         const grouped: { [key: string]: any[] } = {};

      bets.forEach((bet) => {
        const event = bet.eventName;
        if (!grouped[event]) grouped[event] = [];
        grouped[event].push({
          nation: bet.selectionName,
          time: new Date(bet.placingDate).toLocaleString('en-IN', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
          }),
          odds: bet.oddsType == 'Fancy' ? ((bet.score || 0) + '/' + (bet.rate || 0)) : bet.rate,
          bhav: this.getBetBhav(bet),
          amount: bet.stake,
          betType: bet.betType,
          oddsType: bet.oddsType,
          isBack: bet.betType == 'back' || bet.betType == 'yes',
          mode: this.getBetMode(bet)
        });
      });

      // Build markets array and betsData object
      const marketEntries = Object.entries(grouped);
      this.markets = marketEntries.map(([name], index) => ({
        id: `desktop-market${index + 1}`,
        name
      }));

      this.betsData = {};
      marketEntries.forEach(([name, data], index) => {
        this.betsData[`desktop-market${index + 1}`] = data;
      });

      if (this.markets.length && (!this.selectedMarket || !this.betsData[this.selectedMarket])) {
        this.selectedMarket = this.markets[0].id;
      }
      if (!this.markets.length) {
        this.selectedMarket = '';
      }

      // console.log('markets:', this.markets);
      // console.log('betsData:', this.betsData);
    });
  }

  ngAfterContentInit(): void {
    // const dropdown = document.querySelector('.nav-item.nav-dropdown');
    //   const subMenu = dropdown.querySelector('ul');

    //   dropdown.addEventListener('click', () => {
    //     subMenu.classList.toggle('open'); // <-- toggle here
    //   });

//     const dropdown = document.querySelector('.nav-item.nav-dropdown');
// const toggleLink = dropdown.querySelector('.nav-link.nav-dropdown-toggle');
// const subMenu = dropdown.querySelector('.dropdown-menu');

// toggleLink.addEventListener('click', function(e) {
//   e.preventDefault(); 
//   subMenu.classList.toggle('open'); 
// });

const dropdown = document.querySelector('.nav-item.nav-dropdown');
const toggleLink = dropdown.querySelector('.nav-link.nav-dropdown-toggle'); // a tag
const subMenu = dropdown.querySelector('ul');

toggleLink.addEventListener('click', function(e) {
  e.preventDefault(); // <--- stop default <a> behavior
  subMenu.classList.toggle('open'); // toggle open/close
});

  }


   isDropdownOpen = false;

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  // Dropdown close when clicking outside
  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    const target = event.target as HTMLElement;
    const clickedInside = target.closest('.myaccnt');
    if (!clickedInside) {
      this.isDropdownOpen = false;
    }
  }

   logout() {
    this.authService.logout();
  }



      selectedMarket: string = '';

      // markets = [
      //   { id: 'desktop-market1', name: 'Australia W (O)' },
      //   { id: 'desktop-market2', name: 'India W (U)' }
      // ];

      // betsData: any = {
      //   'desktop-market1': [
      //     { nation: 'Australia W (O)', time: '16/10/2025 09:54:26', odds: 1.04, bhav: 0.04, amount: 1000 },
      //     { nation: 'Australia W (O)', time: '16/10/2025 09:55:40', odds: 1.03, bhav: 0.03, amount: 2500 }
      //   ],
      //   'desktop-market2': [
      //     { nation: 'India W (U)', time: '16/10/2025 09:55:32', odds: 1.85, bhav: 0.85, amount: 2000 },
      //     { nation: 'India W (U)', time: '16/10/2025 09:57:12', odds: 1.70, bhav: 0.70, amount: 1200 }
      //   ]
      // };

      getBets(marketId: string) {
        return this.betsData[marketId] || [];
      }

      getBetMode(bet) {
        const isFancy = bet?.oddsType == 'Fancy';
        const isYes = bet?.betType == 'back' || bet?.betType == 'yes';
        if (isFancy) {
          return isYes ? 'YES' : 'NO';
        }
        return isYes ? 'LAGAI' : 'KHAI';
      }

      getBetBhav(bet) {
        const rate = Number(bet?.rate) || 0;
        if (bet?.oddsType == 'Fancy') {
          return rate;
        }
        const bhav = rate > 1 ? rate - 1 : rate;
        return Math.round(bhav * 100) / 100;
      }


      showModal:boolean= false
      checkpopup:boolean= false
      	showpopup() {
    this.showModal = true;
    this.checkpopup = true;
    this.betService.setAllBets();
  }

  hidepopup() {
    this.showModal = false;
    this.checkpopup = false;
  }

  expoList: any[] = [];

  loadExposure() {
    this.expoList = [];
    const userId = this.userName || this.userId;
    if (!userId) {
      return;
    }
    this.userService.getMyExpo({ userId }).subscribe((res: any) => {
      this.expoList = res?.result || [];
    }, error => {
      console.log(error);
      this.expoList = [];
    });
  }

  getExpoSportName(item) {
    const id = String(item?.sportId || '');
    if (id === '4') return 'Cricket';
    if (id === '2') return 'Tennis';
    if (id === '1') return 'Soccer';
    if (id === '7') return 'Horse Racing';
    return item?.sportName || item?.sport || 'Cricket';
  }

  getExpoMarketName(item) {
    if (item?.oddsType != null) {
      return item.oddsType == 'BM' ? 'Bookmaker' : (item.oddsType == 'Fancy' || item.oddsType == 'Khado' ? (item?.runnerName || item.oddsType) : (item.oddsType == 'Toss' ? 'Toss' : 'Match Odds'));
    }
    return item?.runnerName == null ? 'Toss' : item?.runnerName;
  }

    ngOnDestroy(): void {
    this.userSubs.unsubscribe();
    this.messageSubs && this.messageSubs.unsubscribe();
  }
  
}
